<div *ngFor="let afbeelding of koppelpartijAfbeeldingen; let objectIndex = index;">
  <p class="label">Afbeelding {{objectIndex+1}}:</p>
  <input value="{{afbeelding.image}}" (blur)="updateAfbeelding(objectIndex, $event.target);"/> <button class="delete" (click)="deleteAfbeelding(objectIndex)">Verwijder</button><br/>
</div>
<div class="input">
  <button class="add" (click)="addAfbeelding()">Voeg afbeelding toe</button>
</div>
